import { render, staticRenderFns } from "./OptimizedCanvasListsPage.vue?vue&type=template&id=166e9e9a"
import script from "./OptimizedCanvasListsPage.vue?vue&type=script&lang=js"
export * from "./OptimizedCanvasListsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports